import * as React from 'react';
import { getUnixTime } from 'date-fns';
import { useDayPicker } from '../../contexts';
/**
 * Render a row in the calendar, with the days and optionally the week number.
 */
export function Row(props) {
    var _a = useDayPicker(), styles = _a.styles, classNames = _a.classNames, showWeekNumber = _a.showWeekNumber, _b = _a.components, Day = _b.Day, WeekNumber = _b.WeekNumber;
    var weekNumberCell;
    if (showWeekNumber) {
        weekNumberCell = (React.createElement("td", { className: classNames.cell, style: styles.cell },
            React.createElement(WeekNumber, { number: props.weekNumber, dates: props.dates })));
    }
    return (React.createElement("tr", { className: classNames.row, style: styles.row },
        weekNumberCell,
        props.dates.map(function (date) { return (React.createElement("td", { className: classNames.cell, style: styles.cell, key: getUnixTime(date) },
            React.createElement(Day, { displayMonth: props.displayMonth, date: date }))); })));
}
//# sourceMappingURL=Row.js.map